export type Dictionary = { [key: string]: any };

// Wire up all Field Reveal Buttons
document.addEventListener('DOMContentLoaded', () => {
    const fieldRevealButtons = document.querySelectorAll('.field-reveal-button') as NodeListOf<HTMLButtonElement>;

    for (const fieldRevealButton of fieldRevealButtons)
    {
        initializeFieldRevealButton(fieldRevealButton);
    }
});

export function initializeFieldRevealButton(fieldRevealButton: HTMLButtonElement): void
{
    // Find element to be revealed
    const revealElementId = fieldRevealButton.getAttribute('data-reveal-element-id')!;
    const revealElement = document.getElementById(revealElementId);

    if (!revealElement)
    {
        return;
    }

    // Ensure that element to be revealed starts out hidden
    if (!revealElement.classList.contains('hidden'))
    {
        revealElement.classList.add('hidden');
    }

    // When revealer is clicked, expose element to be revealed
    fieldRevealButton.addEventListener('click', () => {
        const fieldRevealButtonContainer = fieldRevealButton.parentElement as HTMLElement;

        // Delete self (and container if it becomes empty)
        fieldRevealButtonContainer.removeChild(fieldRevealButton);
        if (fieldRevealButtonContainer.children.length === 0)
        {
            fieldRevealButtonContainer.remove();
        }

        // Expose other element
        if (revealElement.classList.contains('hidden'))
        {
            revealElement.classList.remove('hidden');
        }
    });
}

export function convertFormDataToDictionary(formData: FormData): Dictionary
{
    const formDataDictionary: Dictionary = {};
    formData.forEach((value, key) => {
        const keys = key.match(/[^[\]]+/g);
        if (keys.length === 1)
        {
            // Handle simple key-value pairs
            formDataDictionary[keys[0]] = value;
        } else
        {
            // Handle indexed key-values
            keys.reduce((acc, key, index) => {
                if (index === keys.length - 1)
                {
                    acc[key] = value;
                } else
                {
                    if (!acc[key])
                    {
                        acc[key] = isNaN(Number(keys[index + 1])) ? {} : [];
                    }
                }
                return acc[key];
            }, formDataDictionary);
        }
    });

    return formDataDictionary;
}
